import {Action, getModule, Module, Mutation, MutationAction, VuexModule} from 'vuex-module-decorators';
import store from '@/model/store/store';
import lgcApi from '@/model/api';
import viewerService from '@/model/services/viewer-service';
import {PUCDataReq, PostUpsertContentsReq} from '@/model/dto/req/contents/post-upsert-contents-req';
import {PUADataReq, PostUpsertAboutReq} from '@/model/dto/req/about/post-upsert-about-req';
import {PUHDataReq, PostUpsertHeadlineReq} from '@/model/dto/req/headline/post-upsert-headline-req';
import {PUMDataReq, PostUpsertMenuReq} from '@/model/dto/req/menu/post-upsert-menu-req';
import {GCICategoryInfoRes, GCIContentsListRes, GCIContentsInfoRes, GCIFeedbackInContentsListRes} from '@/model/dto/res/contents/get-category-list-res';
import {DialogBeforePostInterface} from '@/model/interfaces/content-interface';
import userModule from '@/model/store/modules/user-module';
import _ from 'lodash';

@Module({dynamic: true, store, namespaced: true, name: 'DetailModule'})
class DetailModule extends VuexModule {

  public contents: GCIContentsListRes = {
    category_id: 0,
    category_name: '',
    category_type: '',
    content_id: '',
    user_id: '',
    user_name: '',
    title: '',
    title_new: '',
    text: '',
    text_new: '',
    status: 0,
    created: '',
    updated: null,
    published: null,
    vote: [],
    deleted: false,
    feedback: [],
    hashtag: []
  }; // 詳細ページのデータ
  public breadcrumbs: Array<{
    href: string,
    text: string,
    disabled: boolean
  }> = [];
  public isPreviewDialog: DialogBeforePostInterface<PUCDataReq|PUADataReq|PUHDataReq|PUMDataReq> = {state: false, title: '', message: '', data: null, accountData: null}; // 確認ダイアログデータ

  // Mutations
  @Mutation
  private setContents(contents: GCIContentsListRes): void {
    this.contents = contents;
  }

  @Mutation
  private setContentsTitle(str: string): void {
    this.contents.title = str;
  }

  @Mutation
  private setContentsText(str: string): void {
    this.contents.text = str;
  }

  @Mutation
  private setContentsNewTitle(str: string): void {
    this.contents.title_new = str;
  }

  @Mutation
  private setContentsNewText(str: string): void {
    this.contents.text_new = str;
  }

  @Mutation
  private setBreadcrumbs(
    contents: Array<{
      href: string,
      text: string,
      disabled: boolean
    }>
  ): void {
    this.breadcrumbs = contents;
  }

  @Mutation
  private setIsPreviewDialog(param: DialogBeforePostInterface<PUCDataReq|PUADataReq|PUHDataReq|PUMDataReq>): void {
    this.isPreviewDialog = param;
  }

  // Actions
  /**
   * 詳細ページ
   *
   * @param param
   */
  @Action
  public pushContents(
    param: GCIContentsListRes
  ): void {
    this.setContents(param);
  }

  @Action
  public pushContentsTitle(
    str: string
  ): void {
    this.setContentsTitle(str);
  }

  @Action
  public pushContentsText(
    str: string
  ): void {
    this.setContentsText(str);
  }

  @Action
  public pushContentsNewTitle(
    str: string
  ): void {
    this.setContentsNewTitle(str);
  }

  @Action
  public pushContentsNewText(
    str: string
  ): void {
    this.setContentsNewText(str);
  }

  @Action
  public pushBreadcrumbs(
    param: Array<{
      href: string,
      text: string,
      disabled: boolean
    }>
  ): void {
    this.setBreadcrumbs(param);
  }

  /**
   * プレビュー用ダイアログを表示・非表示
   */
  @Action
  public updateIsPreviewDialog(param: DialogBeforePostInterface<PUCDataReq|PUADataReq|PUHDataReq|PUMDataReq>): void {
    this.setIsPreviewDialog(param);
  }

  /**
   * コンテンツ詳細情報をリクエスト
   *
   */
  @MutationAction({rawError: true})
  public async requestContentsDetailInfo(contentId: string): Promise<any> {
    try {
      const info = await lgcApi.getContentsDetailInfo(contentId);
      return {
        contents: info.contents
      };
    } catch (err) {
      throw err;
    }
  }

}

export default getModule(DetailModule, store);
